import { Navigate } from 'react-router-dom';
import { getLocal } from '../utils/localStorageOps';

export const SignUpRouteDefault = ({ children }) => {
  // console.log(getLocal('zoop_id'))
  return (
  getLocal('nomecadastro') ? (
    getLocal('zoop_id') ? (
      <Navigate to="/cadastro/passo3" />
    ) :
    (
      <Navigate to="/cadastro/passo2" />
    )
  ) : (
    children
  )
)};